import { Component } from '@angular/core';

import { Register } from '../../shared';


@Register({
  name: 'catalogLayers',
  title: 'igo.catalog',
  icon: 'photo_library'
})
@Component({
  selector: 'igo-catalog-layers-tool',
  template: require('./catalog-layers-tool.component.html'),
  styles: [require('./catalog-layers-tool.component.styl')]
})
export class CatalogLayersToolComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/catalog-layers-tool/catalog-layers-tool.component.ts